import { calculateTotalPrice, calculateSavings } from './bulkDiscounts';

export const calculateCartTotals = (cart, shippingMethod) => {
  // Calculate subtotal with all discounts applied
  const subtotal = cart.reduce((sum, item) => {
    // Use the utility function to calculate the total price with discounts
    const itemTotal = calculateTotalPrice(item);
    return sum + itemTotal;
  }, 0);

  // Calculate total savings
  const totalSaved = cart.reduce((sum, item) => {
    // Use the utility function to calculate the savings
    const itemSavings = calculateSavings(item);
    return sum + itemSavings;
  }, 0);

  // Get shipping total
  const shippingTotal = shippingMethod
    ? parseFloat(shippingMethod.settings?.cost?.value || 0)
    : 0;

  // Calculate final total
  const total = subtotal + shippingTotal;

  return {
    subtotal,
    totalSaved,
    shippingTotal,
    total,
  };
};